import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { minHeightDvh } from '../../../theme/mixins';

/**
 * "Check your email", centred on the page.
 *
 * `90dvh` rather than `90vh`: this sits inside the layout's own full-height column, and on
 * a phone the static unit measures the viewport as it would be with the browser chrome
 * retracted -- so the message centred itself against a taller box than the one on screen
 * and sat low, under a scrollbar the page had no other reason to have.
 */
export const pageWrapperStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    ...minHeightDvh('90dvh'),
    textAlign: 'center',
    px: 2,
};

export const subtitleStyles: SxProps<Theme> = {
    mb: 3,
};
